module.exports = __webpack_public_path__ + "img/bannerperfil.f731c870.jpg";